import React from 'react';
import { ContactForm } from './ContactForm';
export function BottomFormSection() {
  return <section className="py-16 bg-gray-50" style={{
    overflow: 'visible',
    height: 'auto'
  }} data-id="element-29">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" style={{
      overflow: 'visible',
      height: 'auto'
    }} data-id="element-30">
        <ContactForm id="form-bottom" title="Start Your Partnership" data-id="element-31" />
      </div>
    </section>;
}